import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useMediaQuery } from "react-responsive";
import Portal from "../components/Portal";
import img1 from "../assets/images/StructuralSteel.png";
import img3 from "../assets/images/StairandRail.jfif";
import img5 from "../assets/images/Connection.jfif";
import img7 from "../assets/images/BuildingInfo.JPG";
import img8 from "../assets/images/ProjectManagement.jfif";
import img9 from "../assets/images/ProjectReport.jfif";
import "../style/ServicesCard.css";

const services = [
  {
    title: "Structural Steel Detailing",
    shortDescription:
      "Our services are designed to meet the specific needs of our clients through the utilization of advanced technical tools and solutions",
    detailDescription:
      "Our services are designed to meet the specific needs of our clients through the utilization of advanced technical tools and solutions, ensuring both efficiency and transparency. We provide high-quality products grounded in a comprehensive understanding of the challenges faced by fabricators, including adherence to contract timelines and addressing gaps in production schedules. By fulfilling deadlines and producing precise drawings, we help prevent any additional costs for the fabricator's clients or erectors. At STEELX, we are committed to employing the appropriate technological tools alongside skilled professionals to deliver optimal solutions in a systematic manner. We assist our clients in streamlining project coordination, enhancing delivery timelines, and elevating overall project quality.",
    service1: "Fabrication & Erection Drawings",
    service2: "Bills of Material",
    service3: "Bolt Lists",
    service4: "Drawing Lists",
    service5: "CNC Production Files",
    image: img1,
  },

  {
    title: "Connection Design",
    shortDescription:
      "Our experienced Engineer carefully prepares supplementary connection calculations whenever necessary.",
    detailDescription:
      "STEELX offers expertly engineered connection designs and calculations that are stamped by professional engineers for various types of steel connections, including column and beam splices, column bases and cap plates, beam-beam connections, beam-column connections, as well as horizontal and vertical brace connections. These designs are tailored to meet the specific requirements of customers regarding loads, materials, and geometry. The loads considered may include shear, axial tension and compression, moments, or combinations thereof. Furthermore, STEELX is equipped to provide stamped calculations for all 50 states in the United States and for major provinces in Canada.",
    service1: "Stamped Engineering Calculations",
    service2: "Beam-to-Beam & Beam-to-Column Connections",
    service3: "Column Splices & Base Plate Designs",
    service4: "Brace Connection Engineering",
    service5: "Load Analysis & Compliance Checks",
    image: img5,
  },
  {
    title: "Miscellaneous Steel Detailing",
    shortDescription:
      "Steel X has expertise in Misc. detailing which included different type of stairs, Handrails, Ramp Rails, Glass Rails, Gates, ladders etc.",
    detailDescription:
      "STEELX possesses specialized knowledge in miscellaneous detailing, encompassing various types of stairs, handrails, ramp rails, glass rails, gates, ladders, and more. We meticulously model the stairs and handrails to ensure their proper integration within the structure.",
    service1: "Stair & Handrail Modeling",
    service2: "Ramp & Glass Rail Detailing",
    service3: "Bolt Lists",
    service4: "Custom Metalwork Integration",
    service5: "Field Fit-up Verification",
    image: img3,
  },
  {
    title: "Building Information Management",
    shortDescription:
      "Steel X understands that a digital, three-dimensional model linked to a database of project information, is one of the most powerful tools supporting IPD.",

    detailDescription:
      "We offer advanced 3D models that integrate fully coordinated Architectural, Structural, and MEP elements, tailored to the specific requirements of each project. Our 3D models facilitate the efficient planning, design, construction, and management of buildings. We maintain that if a design is accurately represented in a 3D model, it can be successfully implemented in the field. Our areas of expertise include Modeling, Coordination of Models among Architectural, Structural, and MEP disciplines, Production of Drawings and Construction Documentation, Creation of Families for various products utilized in the AEC industry, Architectural Walkthroughs and Renderings, Structural Steel Fabrication Drawings, and Intelligent Bill of Quantities, supported by our Back Office.",
    service1: "3D Architectural & Structural Modeling",
    service2: "MEP Coordination & Clash Detection",
    service3: "Intelligent Bill of Quantities (BOQ)",
    service4: "Construction Documentation & Drawings",
    service5: "Architectural Walkthroughs & Renderings",
    image: img7,
  },
  {
    title: "Project Management",
    shortDescription:
      "We have dedicated Project Manager for all the projects which helps our customer to have one point contact with us. ",
    detailDescription:
      "Each of our projects is overseen by a dedicated Project Manager, providing our customers with a single point of contact. STEELX employs a distinctive technique for coordinating work with other trade drawings. Our clients have developed significant trust in our management capabilities, which has facilitated the timely and accurate completion of projects.",
    service1: "Dedicated Project Manager for Coordination",
    service2: "Scheduling & Workflow Optimization",
    service3: "Trade Drawing & Model Integration",
    service4: "Quality Control & Error Mitigation",
    service5: "Client Communication & Progress Reporting",
    image: img8,
  },
  {
    title: "Specialist Report",
    shortDescription:
      "Steel X provides all kind of reports and code files required to expedite the fabrication process.",
    detailDescription:
      "STEELX provides all kind of reports and code files required to expedite the fabrication process. This includes, ABM reports, EJE and KSS files, CNC, DSTV, DXF, Fabtrol files etc...",
    service1: "Advance Bill of Materials (ABM)",
    service2: "EJE & KSS Files for Automation",
    service3: "CNC, DSTV, & DXF Files for Fabrication",
    service4: "Fabtrol Material & Production Files",
    service5: "Compliance & Certification Reports",
    image: img9,
  },
];

const ServicesCard = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const [openStates, setOpenStates] = useState(
    Array(services.length).fill(false)
  );

 
  const handleOpen = (index) => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
    const newOpenStates = [...openStates].map((state, i) => i === index);
    setOpenStates(newOpenStates);
  };

  const handleClose = () => {
    const timeout = setTimeout(() => {
      setOpenStates(Array(services.length).fill(false));
    }, 20);
    setHoverTimeout(timeout);
  };

  return (
    <section className="services-section">
      <h2 className="services-title">
        OUR <span className="highlight">SERVICES</span>
      </h2>
      <p className="services-subtitle">Detailing with SDS/2 Software...</p>
      <div className="services-container">
        {services.map((service, index) => (
          <div
            className="service-card"
            data-aos="flip-left"
            data-aos-duration="1000"
            key={index}
            onClick={() => handleOpen(index)}
            
            
          >
            <div className="image-container">
              <img src={service.image} alt={service.title} />
            </div>
            <h3>{service.title}</h3>
            <p>{service.shortDescription}</p>
            {openStates[index] && (
              <Portal
                onClose={() => handleClose(index)}
                onMouseEnter={() => !isMobile && handleOpen(index)}
                onMouseLeave={() => !isMobile && handleClose()}
                backgroundImage={service.image}
              >
                <h2 className="portal-title">{service.title}</h2>
                <p className="portal-desc">{service.detailDescription}</p>
                <ul className="service-list">
                  <li className="service-list-item">{service.service1}</li>
                  <li className="service-list-item">{service.service2}</li>
                  <li className="service-list-item">{service.service3}</li>
                  <li className="service-list-item">{service.service4}</li>
                  <li className="service-list-item">{service.service5}</li>
                </ul>
              </Portal>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesCard;
